import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PrimeNGModule } from '../../primeng.module';
import { MetaTagsService } from '../../services/meta-tags/meta-tags.service';
import { ProductsService } from '../../services/product/products.service';
import { ToastService } from '../../services/toast/toast.service';
import {
  BreadcrumbComponent,
  BreadcrumbData,
} from '../../shared/components/breadcrumb/breadcrumb.component';
import { ProductsShopDetailsComponent } from '../../shared/components/products-shop-details/products-shop-details.component';
import { ProductsShopComponent } from '../../shared/components/products-shop/products-shop.component';
import { ConfigCategories, Product } from '../../shared/models/product/product';

@Component({
  selector: 'app-products',
  standalone: true,
  imports: [
    BreadcrumbComponent,
    PrimeNGModule,
    ProductsShopComponent,
    ProductsShopDetailsComponent,
  ],
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss',
})
export class ProductsComponent implements OnInit {
  public category: BreadcrumbData = new BreadcrumbData();
  public configCategories?: ConfigCategories;
  public urlName: any;
  public product: Product | undefined = new Product();
  public querySearch: any;
  public sku: any;
  public subCategory: BreadcrumbData = new BreadcrumbData();

  constructor(
    private activatedRoute: ActivatedRoute,
    private metaServices: MetaTagsService,
    private productService: ProductsService,
    public router: Router,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe(async (params) => {
      this.querySearch = params.get('querySearch');
      this.urlName = params.get('name');
      this.sku = params.get('sku');

      if (this.querySearch) {
        this.configProducts();
        this.metaServices.configTagPages(
          MetaTagsService.PAGE_PRODUCTS,
          'produtos/' + this.querySearch,
          '',
          '',
          this.querySearch
        );
      } else if (this.sku) {
        this.configProducts();
        await this.configProductWithSku();
      }
    });
  }

  configProducts() {
    this.configCategories = {
      categories: [],
      categorySelected: undefined,
      subCategorySelected: undefined,
      productsOnOffer: false,
      productsQuerySearch: this.querySearch,
    };
  }

  async configProductWithSku() {
    this.product = this.activatedRoute?.snapshot?.data['product'];
    if (this.product) {
      this.metaServices.configTagPages(
        MetaTagsService.PAGE_PRODUCTS,
        this.sku + '/' + this.urlName,
        this.category?.path,
        this.subCategory?.path,
        this.product
      );
    }
  }
}
